import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import Dashboard from "./pages/dashboard/Dashboard";
import Locker from "./pages/virtual-locker/VirtualLocker";
import LockerV2 from "./pages/virtual-locker/VirtualLockerV2";
import Order from "./pages/order/Order";
import OrderDetailsPage from "./pages/order/OrderDetailsPage";
// import CustomerShopper from "./pages/customer-personal-shopper/CustomerShopper";
import PersonalShopperProducts from "./pages/personalShopper/PersonalShopperProducts";
import GroupCart from "./pages/group-cart/GroupCart";
import NotFound from "./pages/not-found/NotFound";
import SignUp from "./pages/auth/sign-up/SignUpPage";
import Forgot from "./pages/auth/forgot-password/ForgotPage";
import Login from "./pages/auth/login/LoginPage";
import ResetPasswordPage from "./pages/auth/reset-Password/ResetPasswordPage";
import { Toaster } from "react-hot-toast";
import ProfilePage from "./pages/profile/ProfilePage";
import Layout from "./components/common/layout/LayoutPage";
import VerifyEmailPage from "./pages/auth/verify-email/VerifyEmailPage";
import ImageUploader from "./pages/image/image";
import ItemList from "./pages/item/ItemList";
import ItemDetails from "./pages/item/ItemDetails";

//SUPER ADMIN
import AdminDashboard from "./pages/admin/dashboard/AdminDashboard";
import CustomerManagement from "./pages/admin/customer-management/CustomerManagement";
import CustomerDetailPage from "./pages/admin/customer-management/CustomerDetailPage";
import ShopperManagement from "./pages/admin/shopper-management/ShopperManagement";
import ShopperDetailPage from "./pages/admin/shopper-management/ShopperDetailPage";
import ProductManagement from "./pages/admin/products/ProductManagement";
import PrivateRoute from "./pages/private-routing/PrivateRouting";
import VirtualLockerManagement from "./pages/admin/lockers/VirtualLockerManagement";
import OrderManagement from "./pages/admin/orders/OrderManagement";
import AdminSettings from "./pages/admin/settings/AdminSettings";
import RoleManagement from "./pages/admin/role-management/RoleManagement";
import VirtualLockerItemV2 from "./pages/virtual-locker/VirtualLockerItemV2";
import Audit from "./pages/admin/audit/audit";
import GroupCartPage from "./pages/admin/group/GroupCartPage";
import AdminPaymentLogs from "./pages/admin/payment-logs/AdminPaymentLogs";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<PrivateRoute />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<SignUp />} />
          {/* <Route path="/forgot" element={<Forgot />} /> */}
          {/* <Route path="/reset-password" element={<ResetPasswordPage />} /> */}
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          {/* <Route path="/verify-email" element={<VerifyEmail />} /> */}
          {/* <Route path="/image" element={<ImageUploader />} /> */}
          <Route path="/dashboard" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="locker" element={<Locker />} />
            <Route path="locker-v2" element={<LockerV2 />} />
            <Route path="locker/item" element={<VirtualLockerItemV2 />} />
            <Route path="orders" element={<Order />} />
            <Route path="orders/:orderId" element={<OrderDetailsPage />} />
            {/* <Route path="shopper" element={<CustomerShopper />} /> */}
            <Route path="cart" element={<GroupCart />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="items" element={<ItemList />} />
            {/* <Route path="items/:itemId" element={<ItemDetails />} /> */}
            <Route path="payments" element={<NotFound />} />
            <Route path="returns" element={<NotFound />} />
            <Route path="settings" element={<NotFound />} />
            <Route path="help-center" element={<NotFound />} />
          </Route>

          {/* SUPER ADMIN */}
          <Route path="admin" element={<Layout />}>
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="customers" element={<CustomerManagement />} />
            <Route path="customers/:customerId" element={<CustomerDetailPage />} />
            <Route path="shoppers" element={<ShopperManagement />} />
            <Route path="shoppers/:shopperId" element={<ShopperDetailPage />} />
            <Route path="products" element={<ProductManagement />} />
            <Route path="virtual-lockers" element={<VirtualLockerManagement />} />
            <Route path="orders" element={<OrderManagement />} />
            <Route path="orders/:orderId" element={<OrderDetailsPage />} />
            <Route path="settings" element={<AdminSettings />} />
            {/* <Route path="role-management" element={<RoleManagement />} /> */}
            <Route path="audit-log" element={<Audit />} />
            {/* <Route path="payment-logs" element={<AdminPaymentLogs />} /> */}
            <Route path="help-center" element={<NotFound />} />
            <Route path="shipping" element={<NotFound />} />
            <Route path="returns" element={<NotFound />} />
            {/* <Route path="group" element={<GroupCartPage />} /> */}
            <Route path="notifications" element={<NotFound />} />
            <Route path="items" element={<ItemList />} />
            {/* <Route path="items/:itemId" element={<ItemDetails />} /> */}
          </Route>

          {/* personalShopper */}
          {/* <Route path="personal-shopper" element={<Layout />}>
            <Route index element={<Navigate to="products" replace />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="products" element={<PersonalShopperProducts />} />
            <Route path="items/:itemId" element={<ItemDetails />} />
          </Route> */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          duration: 4000,
          style: { zIndex: 9999 },
        }}
      />
    </div>
  );
}

export default App;
